import {UserProfileAdapter} from '@spartacus/user/profile/core';
import {Observable} from 'rxjs';
import {DocumentIdentifierType, JobType, UserTaxGroup} from '../../../../../../spartacus-custom.module';

export abstract class CustomUserProfileAdapter extends UserProfileAdapter {

  abstract loadJobTypes(): Observable<JobType[]>;

  abstract loadDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]>;
  abstract loadUserTaxGroups(): Observable<UserTaxGroup[]>;
}
